/**
 * PDP Marquee Quick-buy — abre cart drawer
 *
 * Comportamento:
 *   - Click em .pdp-marquee__quickbuy → POST /cart/add.js → re-render drawer + abre
 *   - Captura no document em capture phase + stopPropagation pra evitar interferência
 *     do marquee-component.
 *   - Dispatch 'cart:update' (ThemeEvents.cartUpdate) com itemCount + isIncremental=false
 *     pra cart-drawer-component auto-abrir.
 *   - Best-effort fallback: chama drawer.showDialog() diretamente se não abriu.
 */

(function () {
  'use strict';

  if (window.__marqueeQuickbuyInit) return;
  window.__marqueeQuickbuyInit = true;

  function morphSection(sectionId, html) {
    var target = document.getElementById('shopify-section-' + sectionId);
    if (!target) return;
    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + sectionId);
      if (fresh) {
        target.innerHTML = fresh.innerHTML;
      } else if (doc.body) {
        target.innerHTML = doc.body.innerHTML;
      }
    } catch (err) {
      console.warn('[marquee-quickbuy] morph failed', sectionId, err);
    }
  }

  function collectCartSectionIds() {
    var ids = new Set();
    var selectors = [
      'cart-drawer-component',
      'cart-items-component',
      'cart-count-component',
      'cart-bubble'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        var wrapper = el.closest('[id^="shopify-section-"]');
        if (wrapper) ids.add(wrapper.id.replace('shopify-section-', ''));
      });
    });
    return Array.from(ids);
  }

  function openDrawerExplicit() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.showDialog === 'function') {
      try { drawer.showDialog(); } catch (e) { /* noop */ }
    }
  }

  async function handleQuickbuy(btn) {
    var variantId = btn.getAttribute('data-variant-id') || btn.dataset.variantId;
    if (!variantId) {
      console.error('[marquee-quickbuy] missing data-variant-id', btn);
      return;
    }

    var textEl = btn.querySelector('.btn__text');
    var originalLabel = textEl ? textEl.textContent : null;
    btn.setAttribute('disabled', 'true');
    btn.classList.add('pdp-marquee__quickbuy--loading');
    if (textEl) textEl.textContent = 'Adicionando...';

    var sectionIds = collectCartSectionIds();
    var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
    if (sectionIds.length > 0) body.sections = sectionIds.join(',');

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      });

      if (!res.ok) {
        var errData = await res.json().catch(function () { return {}; });
        console.error('[marquee-quickbuy] cart/add failed', { status: res.status, data: errData });
        if (textEl) textEl.textContent = 'Erro';
        setTimeout(function () {
          if (textEl && originalLabel != null) textEl.textContent = originalLabel;
          btn.removeAttribute('disabled');
          btn.classList.remove('pdp-marquee__quickbuy--loading');
        }, 2000);
        return;
      }

      var data = await res.json();

      // morph sections (drawer / count / bubble) pra refletir item novo
      if (data.sections) {
        Object.keys(data.sections).forEach(function (sid) {
          morphSection(sid, data.sections[sid]);
        });
      }

      // Pega cart pra absolute count
      var cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      var cart = await cartRes.json();

      // Dispatch cart:update event — cart-drawer-component escuta e abre se auto-open
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'marquee-quickbuy',
            data: {
              source: 'marquee-quickbuy',
              itemCount: cart.item_count,
              isIncremental: false,
              variantId: variantId,
              sections: data.sections
            }
          }
        })
      );

      // Restaura botão
      if (textEl && originalLabel != null) textEl.textContent = originalLabel;
      btn.removeAttribute('disabled');
      btn.classList.remove('pdp-marquee__quickbuy--loading');

      // Fallback: abre drawer explicitamente se não abriu via evento
      setTimeout(openDrawerExplicit, 80);

      console.log('[marquee-quickbuy] added OK', { itemCount: cart.item_count });
    } catch (err) {
      console.error('[marquee-quickbuy] fetch error', err);
      if (textEl) textEl.textContent = 'Erro';
      setTimeout(function () {
        if (textEl && originalLabel != null) textEl.textContent = originalLabel;
        btn.removeAttribute('disabled');
        btn.classList.remove('pdp-marquee__quickbuy--loading');
      }, 2000);
    }
  }

  function handleClick(e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var btn = target.closest('.pdp-marquee__quickbuy');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    handleQuickbuy(btn);
  }

  // Capture phase (true) — captura ANTES de qualquer listener no DOM
  document.addEventListener('click', handleClick, true);

  console.log('[marquee-quickbuy] listener attached (capture phase, drawer mode)');
})();
